module.exports = __webpack_public_path__ + "static/media/pict-logo.62712bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pict-logo.png
// module id = 510
// module chunks = 0